import { ROLE_HIERARCHY } from '../config/roles';

export function RoleSelector({ currentRole, onSelect }) {
  return (
    <div className="sel-wrap">
      <label className="sel-lbl" htmlFor="role-sel">Role</label>
      <select id="role-sel" value={currentRole} className="sel-ctrl"
        onChange={e => onSelect(e.target.value)}>
        {ROLE_HIERARCHY.map(r => <option key={r} value={r}>{r}</option>)}
      </select>
    </div>
  );
}
